import type { Region } from '@/types/constants';
import { COOKIES, getCookieValue } from '../cookies';
import { COUNTRY_ABBREVIATION } from '../constants';

export const getRegion = async () => getCookieValue(COOKIES.REGION) as Promise<Region>;

export const getCountryCode = () => {
    const key = (process.env.COUNTRY || '').toUpperCase() as keyof typeof COUNTRY_ABBREVIATION;
    return COUNTRY_ABBREVIATION[key];
};
